// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Box, FormField, TextArea } from 'grommet'
import { PropTypes } from 'prop-types'
import styled from 'styled-components'
import { colors } from 'grommet-theme-hpe'

const StyledTextInput = styled(TextArea)`
  background: ${colors?.['background-back']?.light};
  color: ${colors.text.light};
  opacity: 1;
  height: 50px;
  border: none;
`

const FormTextArea = ({
  testId,
  disabled = false,
  label = undefined,
  labelHelper = '',
  action = undefined,
  ...rest
}) => {
  const {
    validate,
    required,
    error,
    name,
    margin,
    htmlFor,
    pad,
    placeholder,
    ...inputProps
  } = rest

  if (action) {
    return (
      <Box direction="row">
        <Box basis="xlarge">
          <FormField
            required={required}
            validate={validate}
            data-testid={`${testId}-field`}
            label={label}
            error={error}
            name={name}
            margin={margin}
            htmlFor={htmlFor}
            pad={pad}
            help={labelHelper}
          >
            <StyledTextInput
              name={name}
              placeholder={placeholder}
              data-testid={`${testId}-area`}
              disabled={disabled}
              {...inputProps}
            />
          </FormField>
        </Box>
        {action}
      </Box>
    )
  }

  return (
    <>
      <FormField
        required={required}
        validate={validate}
        data-testid={`${testId}-field`}
        label={label}
        error={error}
        name={name}
        margin={margin}
        htmlFor={htmlFor}
        pad={pad}
        help={labelHelper}
      >
        <TextArea
          name={name}
          placeholder={placeholder}
          data-testid={`${testId}-area`}
          disabled={disabled}
          {...inputProps}
        />
      </FormField>
    </>
  )
}

FormTextArea.propTypes = {
  testId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelHelper: PropTypes.string,
  action: PropTypes.element
}

export default FormTextArea
